import { motion } from "framer-motion";
import { ShieldCheck, TrendingUp, RefreshCw } from "lucide-react";

const stats = [
  {
    icon: ShieldCheck,
    value: "100%",
    label: "Background-Verified Staff",
    sub: "Aadhar · PAN · Active Bank Account",
    testid: "stat-verification",
  },
  {
    icon: TrendingUp,
    value: "48 hrs",
    label: "On-Demand Scale-Up",
    sub: "Ramp up 30–40% for big sale events",
    testid: "stat-scaling",
  },
  {
    icon: RefreshCw,
    value: "4 hrs",
    label: "Replacement Guarantee",
    sub: "Zero impact on your delivery run sheet",
    testid: "stat-replacement",
  },
];

export const StatsBar = () => (
  <section className="relative bg-[#0a0f1d] py-16 sm:py-20">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid sm:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-sm overflow-hidden">
      {stats.map((s, i) => (
        <motion.div
          key={s.testid}
          data-testid={s.testid}
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ delay: i * 0.12, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="bg-[#0d1424] p-8 sm:p-10 group hover:bg-[#111c33] transition-colors duration-500"
        >
          <s.icon className="w-7 h-7 text-[#d4af37] mb-6 group-hover:scale-110 transition-transform duration-500" />
          <p className="font-display text-5xl sm:text-6xl font-extrabold text-slate-100 leading-none">{s.value}</p>
          <p className="mt-3 text-sm font-bold uppercase tracking-[0.14em] text-slate-200">{s.label}</p>
          <p className="mt-1.5 text-sm text-slate-500">{s.sub}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
